import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.dashboard.userdashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

declare const wiz: any;

@Component({
    selector: 'wiz-portal-dashboard-userdashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.dashboard.userdashboard/view.scss */
/* src/app/portal.dashboard.userdashboard/view.scss: no such file or directory */`],
})
export class PortalDashboardUserdashboardComponent implements OnInit {

    // Select
    public myQaGroupList: any[] = [];
    public selectedMyQAId: 'ALL' | string = 'ALL';

    // Summary
    public myQaReviewSummary: {
        group_id?: string;
        group_name?: string;
        total: number;
        reviewed: number;
        unreviewed: number;
        progress: number;
    } | null = null;
    // 미검수 
    public myQaUnreviewedSummary: {
        unreviewed: number;
    } | null = null;

    // ============================
    // Review Statistics (ALL)
    // ============================
    public myQaReviewStats: {
        approved: number;
        neutral: number;
        rejected: number;
    } | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();

        await this.loadMyQaGroups();

        await this.loadMyQaReviewSummary();
        await this.loadMyQaUnreviewedSummary();
        await this.loadMyQaReviewStats();

        await this.service.render();
    }

    async onChangeMyQA() {
        await this.loadMyQaReviewSummary();
    }

    // ============================
    // Select options
    // ============================
    async loadMyQaGroups() {
        const res = await wiz.call('get_my_assigned_qa_groups');

        const list =
            res?.data?.data ??
            res?.data ??
            [];

        this.myQaGroupList = Array.isArray(list) ? list : [];
        await this.service.render();
    }

    // ============================
    // Review summary
    // ============================
    async loadMyQaReviewSummary() {
        const params: any = {};

        if (this.selectedMyQAId !== 'ALL') {
            params.group_id = this.selectedMyQAId;
        }

        const res = await wiz.call('get_my_qa_review_summary', params);
        this.myQaReviewSummary = res?.data?.data ?? null;

        await this.service.render();
    }
    // 미검수 함수 
    async loadMyQaUnreviewedSummary() {
        const res = await wiz.call('get_my_qa_unreviewed_summary');
        this.myQaUnreviewedSummary = res?.data?.data ?? null;
        await this.service.render();
    }
    // 검수 통계 함수
    async loadMyQaReviewStats() {
        const res = await wiz.call('get_my_qa_review_statistics');
        this.myQaReviewStats = res?.data?.data ?? null;
        await this.service.render();
    }
    //페이지 이동 메서드 추가
    
    goToQaReview() {
        this.router.navigate(['/ui/qadataset']);
    }

}

export default PortalDashboardUserdashboardComponent;